import React from 'react';
import Base from './Base';

export default class TaskDetailModal extends Base {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            record: null,
            commentText: '',
            uploadDoc: { documentType: '', description: '', fileBase64: '', fileName: '' },
            showHelp: false
        };
    }

    componentDidMount() {
        if (this.props.taskId) this.loadTask();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.taskId !== this.props.taskId) {
            this.loadTask();
        }
    }

    loadTask() {
        this.setState({ loading: true });
        this.httpPost('api/v1/task/get', { id: this.props.taskId })
            .then(data => {
                if (data.status === 1) {
                    this.setState({ record: data.record, loading: false });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({ loading: false });
                }
            });
    }

    addComment() {
        if (!this.state.commentText.trim()) return;
        this.httpPost('api/v1/task/addcomment', {
            taskId: this.props.taskId,
            content: this.state.commentText
        }).then(data => {
            if (data.status === 1) {
                const updatedComments = [...this.state.record.comments, data.comment];
                this.setState({
                    record: { ...this.state.record, comments: updatedComments },
                    commentText: ''
                });
            } else this.showErorrMessage(data.message);
        });
    }

    handleFileSelect(e) {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64 = reader.result.split(',')[1];
            this.setState({ uploadDoc: { ...this.state.uploadDoc, fileBase64: base64, fileName: file.name } });
        };
        reader.readAsDataURL(file);
    }

    uploadDocument() {
        if (!this.state.uploadDoc.fileBase64) return;
        this.httpPost('api/v1/task/uploaddocument', {
            taskId: this.props.taskId,
            documentType: this.state.uploadDoc.documentType,
            description: this.state.uploadDoc.description,
            fileBase64: this.state.uploadDoc.fileBase64,
            fileName: this.state.uploadDoc.fileName
        }).then(data => {
            if (data.status === 1) {
                this.showSuccessMessage('مدرک آپلود شد');
                this.loadTask();
                this.setState({ uploadDoc: { documentType: '', description: '', fileBase64: '', fileName: '' } });
            } else this.showErorrMessage(data.message);
        });
    }

    changeStatus(newStatus) {
        const updatedRecord = { ...this.state.record, status: newStatus };
        this.setState({ record: updatedRecord });
        this.httpPost('api/v1/task/save', updatedRecord)
            .then(data => {
                if (data.status === 1) {
                    this.showSuccessMessage('وضعیت با موفقیت تغییر کرد');
                } else {
                    this.showErorrMessage(data.message);
                    this.loadTask();
                }
            });
    }

    render() {
        const { show, onClose, currentUser } = this.props;
        const { loading, record, commentText, uploadDoc, showHelp } = this.state;

        if (!show) return null;
        if (loading || !record) {
            return (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">در حال بارگذاری...</h5>
                                <button type="button" className="close" onClick={onClose}>&times;</button>
                            </div>
                            <div className="modal-body">{this.renderLoading()}</div>
                        </div>
                    </div>
                </div>
            );
        }


        const isAdmin = currentUser?.role === 1;
        const isCreator = record.createdByUserId === currentUser?.id;
        const isSupervisor = record.supervisorUserId === currentUser?.id;
        const isAssignee = record.assignedToUserId === currentUser?.id;

        const isCompleted = record.status === 5;
        const canChangeStatus = !isCompleted && (isAdmin || isCreator || isSupervisor || isAssignee);

        const allowedStatuses = canChangeStatus
            ? ((isAdmin || isCreator || isSupervisor) ? [1, 2, 3, 4, 5] : isAssignee ? [1,2, 3, 4] : [])
            : [];

        // نگاشت وضعیت‌ها
        const statusColor = {
            1: 'secondary',
            2: 'primary',
            3: 'warning',
            4: 'info',
            5: 'success'
        };
        const statusText = {
            1: 'جدید',
            2: 'در حال انجام',
            3: 'نیازمند مدارک',
            4: 'بررسی سرپرست',
            5: 'تکمیل شده'
        };

        return (
            <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{record.title}</h5>
                       
                        </div>


                        <div className="modal-body" style={{ height: '75vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                            <div className="row g-4" style={{ flex: 1, minHeight: 0 }}>

                                <div className="col-md-5 d-flex flex-column">
                                    <div className="card card-bordered flex-grow-1" style={{ overflowY: 'auto' }}>
                                        <div className="card-inner">
                                            <h5 className="card-title">اطلاعات وظیفه</h5>
                                            <dl className="row">
                                                <dt className="col-sm-5">عنوان</dt>
                                                <dd className="col-sm-7">{record.title}</dd>
                                                {record.taskCategory === 2 &&
                                                    <>
                                                    <dt className="col-sm-5">شماره تماس</dt>
                                                    <dd className="col-sm-7">{record.customer.phone}</dd>
                                                    <dt className="col-sm-5">نام طرف قراداد</dt>
                                                    <dd className="col-sm-7">{record.customer.name}</dd>
                                                </>
                                                }
                                               
                                                <dt className="col-sm-5">توضیح</dt>
                                                <dd className="col-sm-7">{record.description || '---'}</dd>

                                                <dt className="col-sm-5">نوع</dt>
                                                <dd className="col-sm-7">
                                                    {record.taskCategory === 1 ? 'داخلی' : record.taskCategory === 2 ? 'قراردادی' : 'تکلیف قانونی'}
                                                </dd>

                                                {record.contractTitle && (
                                                    <>
                                                        <dt className="col-sm-5">قرارداد</dt>
                                                        <dd className="col-sm-7">{record.contractTitle}</dd>
                                                    </>
                                                )}

                                                <dt className="col-sm-5">مجری</dt>
                                                <dd className="col-sm-7">{record.assignedToName || '---'}</dd>

                                                <dt className="col-sm-5">ایجادکننده</dt>
                                                <dd className="col-sm-7">{record.createdByName}</dd>

                                                <dt className="col-sm-5">سرپرست</dt>
                                                <dd className="col-sm-7">{record.supervisorName || '---'}</dd>

                                                <dt className="col-sm-5">اولویت</dt>
                                                <dd className="col-sm-7">
                                                    <span className={`badge ${record.priority === 4 ? 'badge-danger' : record.priority === 3 ? 'badge-warning' : 'badge-info'}`}>
                                                        {record.priority === 1 ? 'کم' : record.priority === 2 ? 'متوسط' : record.priority === 3 ? 'زیاد' : 'حیاتی'}
                                                    </span>
                                                </dd>

                                                <dt className="col-sm-5">وضعیت</dt>
                                                <dd className="col-sm-7">
                                                    {canChangeStatus ? (
                                                        <select
                                                            className="form-select form-select-sm"
                                                            value={record.status}
                                                            onChange={(e) => this.changeStatus(parseInt(e.target.value))}
                                                        >
                                                            {allowedStatuses.map(s => (
                                                                <option key={s} value={s}>{statusText[s]}</option>
                                                            ))}
                                                        </select>
                                                    ) : (
                                                        <span className={`badge badge-${statusColor[record.status]}`}>
                                                            {statusText[record.status]}
                                                        </span>
                                                    )}
                                                </dd>

                                                <dt className="col-sm-5">سررسید</dt>
                                                <dd className="col-sm-7">{new Date(record.dueDate).toLocaleString('fa-IR')}</dd>

                                                {record.startDate && (
                                                    <>
                                                        <dt className="col-sm-5">شروع</dt>
                                                        <dd className="col-sm-7">{new Date(record.startDate).toLocaleString('fa-IR')}</dd>
                                                    </>
                                                )}
                                                {record.completionDate && (
                                                    <>
                                                        <dt className="col-sm-5">پایان</dt>
                                                        <dd className="col-sm-7">{new Date(record.completionDate).toLocaleString('fa-IR')}</dd>
                                                    </>
                                                )}
                                            </dl>
                                        </div>
                                    </div>
                                    <div className="mt-2">
                                        <a href={`/task/edit/${record.id}`} className="btn btn-primary btn-sm">ویرایش کامل</a>
                                        <button className="btn btn-secondary btn-sm ms-2" onClick={onClose}>بستن</button>
                                    </div>
                                </div>

                                <div className="col-md-7 d-flex flex-column" style={{ minHeight: 0 }}>
                                    {/* مکالمات */}
                                    <div className="card card-bordered flex-grow-1 d-flex flex-column" style={{ minHeight: 0, marginBottom: '1rem' }}>
                                        <div className="card-inner d-flex flex-column" style={{ flex: 1, minHeight: 0 }}>
                                            <h5 className="card-title">مکالمات</h5>
                                            <div style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
                                                {record.comments.length === 0 ? (
                                                    <p className="text-muted">هیچ مکالمه‌ای ثبت نشده است.</p>
                                                ) : (
                                                    record.comments.map(c => (
                                                        <div key={c.id} className="mb-3 border-bottom pb-2">
                                                            <strong>{c.userName}</strong> - <small>{c.createdDatePersian}</small>
                                                            <p className="mb-0">{c.content}</p>
                                                        </div>
                                                    ))
                                                )}
                                            </div>
                                            <div className="input-group mt-2">
                                                <input className="form-control" value={commentText}
                                                    onChange={e => this.setState({ commentText: e.target.value })}
                                                    placeholder="پیام خود را بنویسید..." />
                                                <button className="btn btn-primary" onClick={() => this.addComment()}>ارسال</button>
                                            </div>
                                        </div>
                                    </div>

          
                                    <div className="card card-bordered d-flex flex-column" style={{ flex: '0 0 45%', minHeight: 0 }}>
                                        <div className="card-inner d-flex flex-column" style={{ flex: 1, minHeight: 0 }}>
                                            <h5 className="card-title">مدارک پیوست</h5>
                                            <div style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
                                                {record.documents.length === 0 ? (
                                                    <p className="text-muted">مدرکی وجود ندارد.</p>
                                                ) : (
                                                    <ul className="list-group list-group-flush">
                                                        {record.documents.map(d => (
                                                            <li key={d.id} className="list-group-item d-flex justify-content-between align-items-center">
                                                                <span>{d.fileName} ({d.documentType})</span>
                                                                <a href={`/api/v1/task/download/${d.id}`} target="_blank" className="btn btn-sm btn-icon btn-trigger">
                                                                    <em className="icon ni ni-download"></em>
                                                                </a>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </div>
                                            <hr />
                                            <div className="row g-2">
                                                <div className="col-md-4">
                                                    <input className="form-control form-control-sm" placeholder="نوع مدرک"
                                                        value={uploadDoc.documentType}
                                                        onChange={e => this.setState({ uploadDoc: { ...uploadDoc, documentType: e.target.value } })} />
                                                </div>
                                                <div className="col-md-4">
                                                    <input className="form-control form-control-sm" placeholder="توضیح"
                                                        value={uploadDoc.description}
                                                        onChange={e => this.setState({ uploadDoc: { ...uploadDoc, description: e.target.value } })} />
                                                </div>
                                                <div className="col-md-4">
                                                    <input type="file" className="form-control form-control-sm"
                                                        onChange={e => this.handleFileSelect(e)} />
                                                </div>
                                                <div className="col-12">
                                                    <button className="btn btn-success btn-sm" onClick={() => this.uploadDocument()}>
                                                        <em className="icon ni ni-upload"></em> آپلود مدرک
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}